"use strict";

if (typeof Promise === "undefined") {
  window.Promise = require("promise/lib/es6-extensions");
}

// fetch() polyfill for making API calls
require("whatwg-fetch");

// Array.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      return require("lodash").find(this, predicate);
    },
    configurable: true,
    writable: true
  });
}